import React from 'react';
import { connect } from 'react-redux';
import * as userActions from '../../../../redux/user/actions.user';
import {Loader} from '../../../components/Loader/Loader';
import moment from 'moment';
import formats from '../../../../const/formats';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import BillingTileHeader from '../BillingTileHeader/BillingTileHeader';
import Money from '../../../components/Money/Money';
import { List, AutoSizer } from 'react-virtualized/dist/commonjs';

class BillingHistory extends React.Component {

    componentDidMount() {
        const { getPaymentHistory } = this.props;

        getPaymentHistory();
    }

    componentDidUpdate(prevProps) {
        const { getPaymentHistory } = this.props;

        if (prevProps.balance !== this.props.balance) {
            getPaymentHistory();
        }
    }

    setListInView = (ref) => {
        this.list = ref;
    }

    rowRenderer = ({ index, key, style }) => {
        const { billingPayments } = this.props;
        const payment = billingPayments[index];

        return <div key={key} style={style}>
                    <div className="billing-history_list-item">
                        <div className="billing-history_list-item_date">{moment(+payment.createTs).format(formats.paymentDate)}</div>
                        <div className="billing-history_list-item_info">
                            <div>{payment.type} <b className="billing-email">{payment.description}</b></div>
                            <div className="billing-history_list-item_amount"><b><Money amount={payment.amount / 100} /></b></div>
                        </div>
                    </div>
                </div>;
    }

    render() {
        const { billingPayments } = this.props;

        return (
            <div className="billing-history">
                <BillingTileHeader>
                    Credit History
                </BillingTileHeader>
                <div className="billing-history_content">
                    {billingPayments !== null ?
                        <div className="billing-history_list">
                            {billingPayments.length > 0 ?
                                <AutoSizer>

                                    {({height, width}) => (
                                        <List
                                            width={width}
                                            height={height}
                                            rowCount={billingPayments.length}
                                            rowHeight={83}
                                            rowRenderer={this.rowRenderer}
                                            overscanRowCount={2}
                                        />
                                    )}
                                </AutoSizer>
                                : <div style={{ textAlign: 'center' }}>No Credit History</div>
                            }
                        </div> :
                        <div style={{height: "220px"}}>
                            <Loader theme="dark" size="medium" center={true} />
                        </div>
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps({ user }, ownProps) {
    return {
        billingPayments: user.payments,
        balance: user.balance,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getPaymentHistory: () => asyncDispatch(userActions.getPaymentHistory, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BillingHistory);
